<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Workshop Type</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="workshopType.id === null">New</span>
              <span v-else>
                {{ workshopType.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="workshopType.name" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateWorkshopType" class="btn btn-sm btn-primary pull-right" v-show="workshopType.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createWorkshopType" class="btn btn-sm btn-primary pull-right" v-show="workshopType.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ workshopType }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { workshopTypeUrl, getHeader } from '../../config'

export default {
  name: 'WorkshopTypeForm',
  props: ['workshopType'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateWorkshopType () {
      axios.put(workshopTypeUrl + '/' + this.workshopType.id, this.workshopType, { headers: getHeader() })
        .then(response => {
          this.$swal('Job Position', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createWorkshopType () {
      axios.post(workshopTypeUrl, this.workshopType, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
